import { Divider } from '@rneui/base/dist/Divider/Divider';
import { withTheme } from '../config';
export { Divider };
export default withTheme(Divider, 'Divider');
